import React from 'react';

import { isPhone, Popup, getLinkingModalConfig } from '@helpers';
import LevelSelector from '@styles/selectors/level';
import { fullWidth } from '@components/frame';

import ProductionInformation from '@components/productionInformation';
import { NowSubScreenLink } from '@v2/pages/machines/common/enums';
import { useRoute } from '@react-navigation/native';

export default ({ panelViewMode, partId, noMachine, ncFile, partName, clampingTools = [], scale, font, isNCFile, blur, selectedItem, batchText }) => {
  const route = useRoute();

  const noPart = noMachine && !partId && !route.name.includes(NowSubScreenLink.PART); // TODO: add also for ncFiles subscreens
  const levelTabs = [
    noPart
      ? {
          name: 'Part',
          key: 'part',
          value: partName,
          buttonType: true,
          buttonText: 'Add Part Information',
          onPress: () => {
            Popup({
              Component: (p) => (
                <ProductionInformation
                  {...{
                    ...p,
                    onBackPress: p.hide,
                    context: 'ncFile',
                    selectedNCFileId: selectedItem?.machineStatus?.ncFileId,
                    partId: selectedItem?.machineStatus?.partDetails?.partId,
                  }}
                />
              ),
              ...getLinkingModalConfig(scale, fullWidth),
            });
          },
        }
      : {
          name: 'Part',
          key: 'part',
          value: partName,
        },
    {
      name: 'Batch',
      key: 'batch',
      value: batchText,
      empty: !isNCFile,
    },
    {
      name: 'NC File',
      key: 'ncFile',
      value: ncFile,
      buttonType: !isNCFile,
      buttonText: isPhone ? 'NC File' : 'Select NC File',
      itemSliderBG: isNCFile ? false : 'Selected/Light/Slider Add',
    },
    {
      name: 'Tools',
      key: 'tools',
      value: clampingTools?.length || clampingTools?.clampingTools?.length,
    },
  ];

  return <LevelSelector {...{ tabs: levelTabs, big: panelViewMode, scale, font, blur }} />;
};
